<template>
    <v-app>
        <ToastifyContainer />
        <RouterView />
    </v-app>
</template>

<script>
    import 'primeicons/primeicons.css';

    import { ToastifyContainer } from 'vue3-toastify';
    export default {
        name: 'App',
        components: {
            ToastifyContainer,
        },
    };
</script>

<style>
    #app {
        font-family: Inter, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    @font-face {
        font-family: 'Inter';
        font-weight: 300;
        src: local('Inter Light'),
            url(../src/assets/font/Inter/Inter-Light.ttf) format('truetype');
    }
    @font-face {
        font-family: 'Inter';
        font-weight: 400;
        src: local('Inter Regular'),
            url(../src/assets/font/Inter/Inter-Regular.ttf) format('truetype');
    }
    @font-face {
        font-family: 'Inter';
        font-weight: 500;
        src: local('Inter Medium'),
            url(../src/assets/font/Inter/Inter-Medium.ttf) format('truetype');
    }
    @font-face {
        font-family: 'Inter';
        font-weight: 600;
        src: local('Inter SemiBold'),
            url(../src/assets/font/Inter/Inter-SemiBold.ttf) format('truetype');
    }
    @font-face {
        font-family: 'Inter';
        font-weight: 700;
        src: local('Inter Bold'),
            url(../src/assets/font/Inter/Inter-Bold.ttf) format('truetype');
    }
    @font-face {
        font-family: 'Inter';
        font-weight: 800;
        src: local('Inter ExtraBold'),
            url(../src/assets/font/Inter/Inter-ExtraBold.ttf) format('truetype');
    }
    @font-face {
        font-family: 'Inter';
        font-weight: 900;
        src: local('Inter Black'),
            url(../src/assets/font/Inter/Inter-Black.ttf) format('truetype');
    }

    @font-face {
        font-family: 'Alex Brush';
        src: url(../src/assets/font/Alex_Brush/AlexBrush-Regular.ttf)
            format('truetype');
    }

    @font-face {
        font-family: 'Amoresa';
        src: url(../src/assets/font/Amoresa/Amoresa.ttf) format('truetype');
    }

    @font-face {
        font-family: 'Crimson Pro';
        src: url(../src/assets/font/Crimson_Pro/CrimsonPro-Regular.ttf)
            format('truetype');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Crimson Pro';
        src: url(../src/assets/font/Crimson_Pro/CrimsonPro-Bold.ttf)
            format('truetype');
        font-weight: 700;
    }

    @font-face {
        font-family: 'Garet';
        src: url(../src/assets/font/Garet/Garet-Book.ttf) format('truetype');
    }

    @font-face {
        font-family: 'Open Sans';
        src: url(../src/assets/font/Open_Sans/OpenSans-VariableFont.ttf)
            format('truetype');
        font-weight: 300 800;
        font-display: swap;
    }

    @font-face {
        font-family: 'Playfair Display';
        src: url(../src/assets/font/Playfair_Display/PlayfairDisplay-Bold.ttf)
            format('truetype');
        font-weight: 700;
    }

    @font-face {
        font-family: 'Unna';
        src: url(../src/assets/font/Unna/Unna-Regular.ttf) format('truetype');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Unna';
        src: url(../src/assets/font/Unna/Unna-Bold.ttf) format('truetype');
        font-weight: 700;
    }

    svg.svg-inline--fa {
        font-size: 20px;
    }
    section.section.page-body.primary {
        background-color: white;
        height: calc(100vh - 200px);
        border-radius: 0px 0px 10px 10px;
    }
    button.btn.btn-secondary,
    button.btn.btn-primary {
        color: white;
    }
    @media only screen and (min-width: 1500px) {
        section.section.page-body.primary {
            height: calc(100vh - 250px);
        }
    }
</style>
